module.exports = __webpack_public_path__ + "static/media/TwitterSocial.a63570eb.svg";